import { _APP_CONFIG } from "../../core/config/AppConfig";
import { licenseService } from "../../core/services/license-service";
import { CLicenciaModuloExtra } from "../../core/types/LicenciaTypes";
import { UIUtilPermission } from "../../ui/util/Permission";
import { Entidad } from "../Entidad";
import { IEscuela } from "../entidad/Escuela";
import { _DICC_ASIGNACION_ESCUELA_ESCOLARIDADES } from "../modulo/Escuela";
import { _DICC_GRUPO } from "../modulo/Grupo";
import { DataModuloMain } from "../ModuloMain";
import { MEscolaridad } from "./MEscolaridad";
import { MGrupo } from "./MGrupo";
import { ModelAdapter } from "./ModelAdapter";

export class MEscuela extends ModelAdapter<IEscuela> implements IEscuela {
    readonly IdKinder: number;
    readonly ConLogo: boolean;
    readonly Correo: string;
    readonly Direccion: string;
    CodigoPais: string;
    readonly EnUso: boolean;
    readonly HoraEntradas: string[];
    readonly HoraSalidas: string[];
    readonly Modificacion: string;
    readonly Nombre: string;
    readonly Tamanio: number;
    readonly Telefono: string; // Se modifica para aplicarle la LADA cuando no viene (resgistros legacy).
    readonly TipoLicencia: Entidad.CTipoLicencia;
    readonly UsaEntradaSalidaQR: boolean;
    readonly ZonaHoraria: string;
    readonly CalendarioCfg: boolean;
    readonly UsaFinanzas: boolean;
    readonly UsaFactura: boolean;
    readonly FechaRegistro: string;
    readonly ModuloEval: Entidad.CTipoEvento.Logros | Entidad.CTipoEvento.Evaluacion;

    TiempoCobro: number;
    ToleranciaFactura: number;
    ToleranciaRetraso: number;
    Logo: string;
    Entrada: string;
    Salida: string;
    KinderFiltro?: number[];

    constructor(data: IEscuela) {
        super(data);
        this._init();
    }

    private _init() {
        this.KinderFiltro = [this.IdKinder];

        if (this.ConLogo)
            this.Logo = this.getUrlObtenerLogo();
        else
            this.Logo = null;

        this.Entrada = this.HoraEntradas.find(d => Boolean(d)) || "";
        this.Salida = this.HoraSalidas.find(d => Boolean(d)) || "";
    }

    // =================================================
    // GETTERS ADICIONALES
    // =================================================

    get usaFactura(): boolean {
        if (!UIUtilPermission._HasAccionPermission(Entidad.CAccionPermiso.Editar, Entidad.CModulo.FinanzasFacturacion, this.IdKinder)) {
            return false;
        }
        return this.usaFactura;
    }

    get usaFinanzas(): boolean {
        if (!licenseService._HasModuloExtra(CLicenciaModuloExtra.Finanzas)) {
            return false;
        }
        return this.usaFinanzas;
    }

    get alumnosDeEscuela(): Map<number, Entidad.IAlumno> {
        let alumnos: Map<number, Entidad.IAlumno> = new Map();

        DataModuloMain._GetReqDataMapById(Entidad.CTipoRequest.Alumno)
            .forEach(alumno => {
                if (alumno.IdKinder == this.IdKinder && alumno.EnUso) {
                    alumnos.set(alumno.IdChild, alumno);
                }
            })

        return alumnos;
    }

    get escolaraidadesDeEscuela(): Map<number, MEscolaridad> {
        return (_DICC_ASIGNACION_ESCUELA_ESCOLARIDADES.get(this.IdKinder) || new Map());
    }

    get gruposDeEscuela(): Map<number, MGrupo> {
        const grupos = new Map<number, MGrupo>();

        // return grupos;
        _DICC_GRUPO
            .forEach((d, k) => {
                if (d.IdKinder == this.IdKinder) {
                    grupos.set(k, d);
                }
            });

        return grupos;
    }

    get latitudLongitud(): string {
        let splitDirection = (this.Direccion || "").split("\n");
        if (splitDirection.length != 8) return null;
        return splitDirection[7];
    }

    // =================================================
    // METODOS PÚBLICOS
    // =================================================

    public getUrlObtenerLogo(): string {
        return `${_APP_CONFIG.URL_RSTV2}escuela/ObtenerLogo?IdEscuela=${this.IdKinder}&Modificacion=${this.Modificacion}`;
    }
}